module.exports = __webpack_public_path__ + "media/images/icon-customer-journey-0961e38960467a1130b9168279e6fec3.svg";